// Classificação IBS/CBS do produto (S27b). cClassTrib vazio = não
// classificado: o produto aparece como "pendente".

export function classificacaoPendente(produto) {
  return !String(produto?.cclasstrib || '').trim();
}

// Indicador do painel do escritório por empresa. `p` vem de
// /rtc/pendencias-classificacao: { obrigada, produtos_ativos, sem_classificacao }.
// tipo: 'nao_obrigada' | 'pendente' | 'ok'.
export function resumoPendenciaEmpresa(p) {
  if (!p || !p.obrigada) return { tipo: 'nao_obrigada', texto: '—' };
  const n = Number(p.sem_classificacao) || 0;
  if (n > 0) return { tipo: 'pendente', texto: `${n} sem classificação` };
  return { tipo: 'ok', texto: 'classificados' };
}
